import { has, set } from 'lodash-es'
import { CONSTANTS } from './state'
import { REQUEST_STATE } from './constants'
import { stateSets } from './state'

export const TYPES = {
  SET_CONNECTION_STATE: 'SET_CONNECTION_STATE',
  ...Object.keys(stateSets).reduce((types, type) => ({ ...types, [type]: type }), {}),
}

export default Object.entries(stateSets).reduce(
  (mutations, [key, type]) => {
    mutations[key] = (state, payload) => {
      switch (payload.type) {
        case REQUEST_STATE.STATE_PENDING: {
          set(state, type.stateKey, payload.type)
          set(state, type.modifiedKey, new Date())
          if (has(payload, 'data')) {
            set(state, type.dataKey, payload.data)
          }
          // if (has(payload, 'cancelSource')) {
          //   set(state, type.cancelSource, payload.cancelSource)
          // }
          return
        }
        case REQUEST_STATE.STATE_SUCCESS:
          set(state, type.stateKey, payload.type)
          set(state, type.modifiedKey, new Date())
          set(state, type.dataKey, payload.data)
          set(state, type.statusCodeKey, payload.status)
          set(state, type.messageKey, null)
          // set(state, type.cancelSource, null)
          return
        case REQUEST_STATE.STATE_FAILURE:
          set(state, type.stateKey, payload.type)
          set(state, type.modifiedKey, new Date())
          set(state, type.messageKey, payload.errorMessage)
          set(state, type.statusCodeKey, payload.status)
          // set(state, type.dataKey, payload.data)
          // set(state, type.cancelSource, null)
          return
        case REQUEST_STATE.STATE_INITIAL:
          set(state, type.stateKey, payload.type)
          set(state, type.modifiedKey, new Date())
          set(state, type.messageKey, null)
          set(state, type.statusCodeKey, null)
          set(state, type.dataKey, null)
        // set(state, type.cancelSource, null)
      }
    }
    return mutations
  },
  {
    [TYPES.SET_CONNECTION_STATE]: (state, payload) => {
      state[CONSTANTS.CONNECTION_STATE] = payload
    },
  },
)
